/**
 * hrd.AbstractCommonInterface.js
 */
hrd.AbstractCommonInterface = hrd.Class.extend({
	init: function(options){
		this.doMixin();
		options = options || {};
		if(options.prefix == undefined){
			options.prefix = $('<div></div>').uniqueId().attr('id');
		}
		var defaults = {
			impl: 'hrd.AbstractCommonInterface',
			prefix: ''
		};
		this._super($.extend({}, defaults, options));
		/* prepare ad hoc hashcode */
		let hashcode = this.getToolbox().generateMarker({prefix: `${this.settings.impl}@`});
		this.settings.hashcode = hashcode;

		// copy in this settings all business mixin settings
		if(this.mixinSettings != undefined && this.mixinSettings.length > 0){
			let ignore = ['impl', 'prefix'];
			this.mixinSettings.forEach(ms => {
				Object.keys(ms).forEach(s => {
					if(ignore.indexOf(s) == -1){
						this.settings[s] = ms[s];
					}
				});
			});

			if(typeof this.doInitializeMixin === 'function') {
				this.doInitializeMixin.bind(this)(this.settings);
			}
			delete this.mixinSettings; // delete it, not needed anymore
		}
	},
	doMixin: $.noop,
	_toId: function(type){
		return this.settings.prefix + '-' + type;
	},
	_toIdSelector: function(type){
		return '#' + this._toId(type);
	},
	/**
	 * Used to return Toolbox instance, in lazy creation.
	 */
	getToolbox: function() {
		if(this.toolbox === undefined) {
			this.toolbox = new hrd.Toolbox();
		}
		return this.toolbox;
	}	
});